import nvSharedServicesModule from '../../shared/services/nv.shared.services.module';
import { AbsentStudentsListModule } from './absent-students-list/absent-students-list.module';
import { SupportsRosterModule } from './supports-roster/supports-roster.module';

export default angular.module('nv.SupportsModule', [
  'md.data.table',
  nvSharedServicesModule,
  SupportsRosterModule,
  AbsentStudentsListModule,
  'mdSteppers',
  'nv.shared.modals',
]).name;
